document.addEventListener("DOMContentLoaded", function(){
  const form = document.getElementById("enrollForm");
  if (!form) return; // Agar form page par nahi hai to kuch mat karo

  form.addEventListener("submit", function(e){
    e.preventDefault(); // Page reload hone se rokta hai
    const formData = new FormData(form);

    // 🔗 Replace this URL with your deployed Google Apps Script Web App URL
    const scriptURL = "https://script.google.com/macros/s/AKfycbz0j7-hTAKVhcQ5dg4EM-jmrdq-M8imYC-5w_lmoIUJYH9wQRZyq5nn90-IC3F9Sg1l/exec";

    fetch(scriptURL, { method: "POST", body: formData })
      .then(res => res.text())
      .then(() => {
        const msg = document.getElementById("responseMsg");
        if (msg) {
          msg.innerText = "✅ Thank you for submitting this form. Our team will call you back shortly.";
          msg.style.color = "green";
        }
        form.reset();
      })
      .catch(err => {
        console.error("Form submission error:", err);
        const msg = document.getElementById("responseMsg");
        if (msg) {
          msg.innerText = "❌ There was an error submitting the form. Please try again later.";
          msg.style.color = "red";
        }
      });
  });
});
